import { J1LeftarrowA, J1RightarrowA } from '@e3dc-react/icons'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box } from '@mui/material'
import React from 'react'
import { useShopHorizontalScroll } from 'src/Libs/shop/hooks'
import { Product } from 'src/Libs/shop/models/system-configuration-components.model'
import { makeStyles } from 'tss-react/mui'
import QntmProductCard from './QntmProductCard'

interface QntmCardComponentProps {
  qntmProduct: Product
  onMoreInfo: (productId: string) => void
}

const useStyles = makeStyles()(theme => ({
  gridContainer: {
    display: 'flex',
    overflowX: 'auto',
    width: '100%',
    minWidth: '30px',
    flexWrap: 'nowrap',
    marginLeft: '12px',
    position: 'relative',
  },
  paperContent: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingRight: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    overflowX: 'hidden',
    position: 'relative',
    [theme.breakpoints.down('xs')]: {
      minWidth: '100%',
      paddingRight: 0,
    },
  },
  leftArrow: {
    position: 'absolute',
    top: '50%',
    left: 0,
    transform: 'translateY(-50%)',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    padding: theme.spacing(0),
    color: theme.palette.primary.contrastText,
    minWidth: '32px',
    minHeight: '32px',
  },
  rightArrow: {
    position: 'absolute',
    top: '50%',
    right: -20,
    transform: 'translateY(-50%)',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    padding: theme.spacing(0),
    color: theme.palette.primary.contrastText,
    minWidth: '32px',
    minHeight: '32px',
  },
}))

const QntmCardComponent: React.FC<QntmCardComponentProps> = ({ qntmProduct, onMoreInfo }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { containerRef, canScrollToLeft, canScrollToRight, handleScrollLeft, handleScrollRight } = useShopHorizontalScroll()
  return (
    <Paper title={t('shop.system-configuration.quantum-card-component-title')} className={classes.paperContent}>
      <Box className={classes.gridContainer} ref={containerRef}>
        <QntmProductCard key={qntmProduct.id} productData={qntmProduct} onMoreInfo={onMoreInfo} />
      </Box>
      {canScrollToLeft && <J1LeftarrowA className={classes.leftArrow} onClick={handleScrollLeft} />}
      {canScrollToRight && <J1RightarrowA className={classes.rightArrow} onClick={handleScrollRight} />}
    </Paper>
  )
}

export default QntmCardComponent
